module.exports = "/work-site/img/pcms.8aa84eda.png";